import { render, staticRenderFns } from "./CreateCountry.vue?vue&type=template&id=700886d4"
import script from "./CreateCountry.vue?vue&type=script&lang=js"
export * from "./CreateCountry.vue?vue&type=script&lang=js"
import style0 from "./CreateCountry.vue?vue&type=style&index=0&id=700886d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports